import React, { useEffect, useState } from "react";
import moment from "moment";
import {
	Button,
	CircularProgress,
	Drawer,
	MenuItem,
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField
} from "@mui/material";
import  {LoadingButton } from "@mui/lab";
import FunctionsData from "../../../Functions/FunctionsData";
import StaffInvoicesShowTable from "./StaffInvoicesShowTable";

export default function StaffInvoices() {
	const [loadingNew, setLoadingNew] = useState(true);
	const [loading, setLoading] = useState(true);
	const [loadingMonthInvoices, setLoadingMonthInvoices] = useState(false); // Responsible for the loading state when the selected month's invoices are being fetched
	const [data, setData] = useState([]);
	const [dataNew, setDataNew] = useState([]);
	const [dataFiltered, setDataFiltered] = React.useState([]);
	const [dataFilteredNew, setDataFilteredNew] = React.useState([]);
	const [filter, setFilter] = useState("");
	const [filterNew, setFilterNew] = useState("");
	const [termsFilterNew, setTermsFilterNew] = useState([]);
	const [monthsList, setMonthsList] = useState([]);
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [mode, setMode] = useState('invoices');
	
	useEffect(() => {
		FunctionsData.fetchDataGet(FunctionsData.getApiUrl('/api/merco/invoiced/months'), setMonthsList, true, setLoading);
	}, [loading]);

	useEffect(() => {
		// Check if a month has been selected
		if (monthsList.length > 0) {
			monthsList.sort((a, b) => {
				return moment(b.mth).format('YYYYMM') - moment(a.mth).format('YYYYMM');
			})
			let s = selectedMonth;
			if(!selectedMonth) {
				s = monthsList[0].mth;
				setSelectedMonth(s);
			}
			if (selectedMonth && selectedMonth !== "selectAll") {
                setLoadingMonthInvoices(true);
                FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl(`/api/merco/invoiced?month=${selectedMonth}`), (data) => {
                    setData(data);
                    setLoadingMonthInvoices(false);
                });
            } else if (selectedMonth === "selectAll") {
                setLoadingMonthInvoices(true);
                FunctionsData.fetchDataGetNoLoading(FunctionsData.getApiUrl(`/api/merco/invoiced`), (data) => {
                    setData(data);
                    setLoadingMonthInvoices(false);
                });
            }
		}
	}, [selectedMonth, monthsList]);

	useEffect(() => {
		FunctionsData.fetchDataGet(
			FunctionsData.getApiUrl('/api/merco/new'), setDataNew, loadingNew, setLoadingNew);
	}, [loadingNew]);

	useEffect(() => {
		filterMe();
	}, [data, filter, selectedMonth]);

	useEffect(() => {
		filterNewData();
	}, [dataNew, filterNew, termsFilterNew]);

	function filterMe(e) {
		let d = data;
		let newData = [];

		if (filter.trim() !== '') {
			for (let x in d) {
				let obj = d[x];
				let include = false;
				for (let y in obj) {
					let obj2 = obj[y];
					if (String(obj2).toLowerCase().includes(filter.trim().toLowerCase())) {
						include = true;
					}
				}
				if (include === true) {
					newData.push(obj);
				}
			}
		} else {
			newData = data;
		}

		// Cluster by month and filter the selected month
		if (selectedMonth && selectedMonth !== "selectAll") {
            newData = newData.filter((item) => {
                const itemDate = moment(item.created_at);
                return itemDate.format('YYYY-MM-01') === selectedMonth;
            });
        }

		setDataFiltered(newData);
	}

	function filterNewData() {
		let d = dataNew;
		let newData = [];

		if (filterNew.trim() !== '') {
			for (let x in d) {
				let obj = d[x];
				let include = false;
				for (let y in obj) {
					let obj2 = obj[y];
					if(String(obj2).toLowerCase().includes(filterNew.trim().toLowerCase())) {
						include = true;
					}
				}
				if (include === true) {
					newData.push(obj);
				}
			}
		} else {
			newData = dataNew;
		}

		// Apply BCTI/Terms filter for new schedules (multi-select)
		if (Array.isArray(termsFilterNew) && termsFilterNew.length > 0 && !termsFilterNew.includes('all')) {
			newData = newData.filter((row) => {
				const bcti = Number(row.BCTI);
				const terms = (row.Terms || '').toString().toUpperCase();
				const matchBctiOut = bcti === 0;
				const match7d = terms.includes('7D');
				const matchMonthly = terms !== '' && !terms.includes('7D');
				return (
					(termsFilterNew.includes('bcti_out') && matchBctiOut) ||
					(termsFilterNew.includes('terms_7d') && match7d) ||
					(termsFilterNew.includes('terms_monthly') && matchMonthly)
				);
			});
		}

		setDataFilteredNew(newData);
	}

	function handleClear() {
        setSelectedMonth("selectAll");
    }

	if (loading === true || loadingNew === true) {
		return <CircularProgress sx={{ margin: "50px auto", display: "block" }} />;
	};

	if(mode === 'invoices') return (
		<>
			<div style={ {marginBottom: 20} }>
				<Button style={ {marginRight: 10} } variant={ 'contained' } disabled={ mode === 'invoices' } onClick={ () => setMode('invoices') }>Show upcoming invoices</Button>
				<Button variant={ 'contained' } disabled={ mode === 'schedules' } onClick={ () => setMode('schedules') }>Show new schedules</Button>
			</div>
			{ dataNew.length > 0 ? (
				<>
					<h3 style={{ margin: '20px 0' }}>New schedules available</h3>
					<div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
						<TextField
							id="standard-basic-new"
							placeholder={"Filter new schedules..."}
							variant="outlined"
							size={"small"}
							sx={{ flexGrow: 1 }}
							value={filterNew}
							onChange={(e) => setFilterNew(e.target.value)}
						/>
						<TextField
							id="terms-filter-new"
							select
							size={"small"}
							label="Filter by"
							SelectProps={{
								multiple: true,
								value: termsFilterNew,
								onChange: (e) => {
									const value = e.target.value;
									setTermsFilterNew(typeof value === 'string' ? value.split(',') : value);
								},
								renderValue: (selected) => {
									if (!Array.isArray(selected) || selected.length === 0) return 'All';
									const labelsMap = {
										all: 'All',
										bcti_out: 'BCTI - Opted Out',
										terms_7d: '7D Terms',
										terms_monthly: 'Monthly Terms',
									};
									return selected.map((key) => labelsMap[key] || key).join(', ');
								},
							}}
							sx={{ minWidth: 220 }}
						>
							<MenuItem value="all">All</MenuItem>
							<MenuItem value="bcti_out">BCTI - Opted Out</MenuItem>
							<MenuItem value="terms_7d">7D Terms</MenuItem>
							<MenuItem value="terms_monthly">Monthly Terms</MenuItem>
						</TextField>
					</div>
					<StaffInvoicesShowTable
						setDataFiltered={setDataFiltered}
						dataFiltered={dataFilteredNew}
						setLoading={setLoading}
						setLoadingNew={setLoadingNew}
					/>
					<hr style={{ margin: '20px 0' }} />
				</>
			) : undefined}
		</>
	)
	
	return (
		<>
			<div style={{marginBottom:20}}>
				<Button style={ {marginRight: 10} } variant={ "contained" } disabled={ mode === 'invoices' } onClick={ () => setMode('invoices') }>Show upcoming invoices</Button>
				<Button variant={ "contained" } disabled={ mode === 'schedules' } onClick={ () => setMode('schedules') }>Show new schedules</Button>
			</div>
			{ monthsList.length > 0 && (
				<>
					<div style={{display:'flex'}}>
						<TextField
							id="standard-basic"
							placeholder={ "Filter invoices..." }
							variant="outlined"
							size={ "small" }
							sx={ {flexGrow: 1, marginBottom: 2} }
							value={ filter }
							onChange={ (e) => setFilter(e.target.value) }
						/>
						<TextField
							id="month-selector"
							select
							size={ "small" }
							label="Select Month"
							value={selectedMonth || ""}
							sx={ {flexGrow: 0, marginBottom: 2, minWidth:250, marginLeft:2} }
							onChange={ (e) => setSelectedMonth(e.target.value) }
							helperText="Please select a month"
						>
							{/* Populate the dropdown with unique months from the data */ }
							<MenuItem key={"selectAll"} value={"selectAll"}>
                        		All
                            </MenuItem>
							{ monthsList.map((item) =>
							{
								return (
									<MenuItem key={ item.mth } value={ item.mth }>
										{ moment(item.mth).format("MMMM YYYY") }
									</MenuItem>
								);
							}) }
						</TextField>
						<Button variant={"contained"} sx={{ marginLeft: 2, height: '40px' }} onClick={handleClear}>
                            Clear
                        </Button>
					</div>
					
					{ loadingMonthInvoices ? (
						<CircularProgress sx={ {margin: "50px auto", display: "block"} }/>
					) : (
						<StaffInvoicesShowTable
							setDataFiltered={ setDataFiltered }
							dataFiltered={ dataFiltered }
							setLoading={ setLoading }
							setLoadingNew={ setLoadingNew }
						/>
					) }
				</>
			) }
		</>
	);
}
